export default __webpack_public_path__ + "static/media/dinesh.55c384e5.png";